import{Subscriber as r}from"../Subscriber.js";function n(n){for(;n;){var o=n,t=o.closed,e=o.destination,i=o.isStopped;if(t||i)return!1;n=e&&e instanceof r?e:null}return!0}export{n as canReportError};
